VjsAdmin.License = (function () {
    const me = {};

    let $table;
    let $modal;
    me.order_by = 'district_id';
    me.sort_order = 'desc';
    const tableHeight = window.innerHeight * 0.65;

    const queryParams = function (params) {
        const myParams = VjsTable.tableDefaults().queryParams.call(this, params);
        myParams.sort_order = me.sort_order;
        myParams.order_by = me.order_by;
        myParams.search_term = $('.fixed-table-toolbar .search > input').val();
        return myParams;
    };

    const initTable = function () {
        $table = $('#districts-table');
        const platformId = $table.attr('data-platform-id');
        $table.addClass('loading');

        $table.bootstrapTable({
            ...VjsTable.tableDefaults(),
            table: '#districts-table',
            formatNoMatches() {
                const searchTerm = $('.fixed-table-toolbar .search input').val();
                return `No districts ${typeof searchTerm !== 'undefined' ? ` matching search term \`${searchTerm}\`` : ''}`;
            },
            queryParams,
            toolbar: '#report-toolbar',
            toolbarAlign: 'left',
            sortName: 'district_id',
            height: tableHeight,
            singleSelect: true,
            clickToSelect: true,
            maintainSelected: true,
            onCheck() {
                $('#change-district-button').prop('disabled', false);
            },
            url: Slim.Router.pathFor('platforms.districts.list.json', {
                platform_id: platformId,
            }),
            columns: [
                {
                    title: '',
                    field: 'selected',
                    align: 'center',
                    valign: 'middle',
                    sortable: false,
                    radio: true,
                },
                {
                    title: 'ID',
                    field: 'district_id',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Name',
                    field: 'name',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'State',
                    field: 'state_code',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                },
            ],
            responseHandler(res) {
                const formattedResult = {};
                formattedResult.total = res.meta.total;
                formattedResult.rows = res.data;

                $(formattedResult.rows).each((i, row) => {
                    // we're getting a UTC date from the DB... need to convert it to the users timezone...?
                    row.is_active = row.active;

                    if (+row.active === 0) {
                        row.active = '<i class="fa fa-times text-danger" aria-hidden="true"></i>';
                    } else {
                        row.active = '<i class="fa fa-check text-success" aria-hidden="true"></i>';
                    }
                });
                return formattedResult;
            },
            onSort(name, order) {
                VjsTable.tableDefaults().onSort.call(this, name, order);
                me.order_by = name;
                me.sort_order = order;
            },
        });
    };

    const init = function () {
        me.order_by = $.urlParam('order_by') != null ? $.urlParam('order_by') : 'district_id';
        me.sort_order = $.urlParam('sort_order') != null ? $.urlParam('sort_order') : 'desc';

        $('.unlock-district-field').on('mousedown', () => {
            $('.unlock-district-field .fa').toggleClass('fa-unlock').toggleClass('fa-lock');
            $('#district_id').prop('disabled', !$('#district_id').prop('disabled'));
        });

        $('#district_id').on('mousedown', (e) => {
            e.preventDefault();
            const content = $('<div>').html($('#change-district-template').html());

            const submitButton = $(
                '<button type="button" class="btn btn-green" id="change-district-button" disabled>Change District</button>',
            );

            const onShown = function () {
                initTable();
            };

            $(submitButton).on('click', (ee) => {
                ee.preventDefault();
                const districtId = $table.bootstrapTable('getSelections')[0].district_id;
                const name = typeof $table.bootstrapTable('getSelections')[0].display_name !== 'undefined'
                    ? $table.bootstrapTable('getSelections')[0].display_name
                    : $table.bootstrapTable('getSelections')[0].name;
                $('#district_id > option').val(districtId);
                $('#district_id > option').text(name);
                $('.unlock-district-field').remove();
                $modal.modal('hide');
            });

            $modal = VjsAdmin.Modal.create({
                title: 'Change District',
                body: content,
                footer: submitButton,
                onShown,
            });

            $modal.modal();

            return false;
        });
    };

    return {
        init,
    };
}());
